import React from "react";
import { FinanceKnowledge } from "app/financeKnowledge/FinanceKnowledge/FinanceKnowledge";
import { useFinanceKnowledge } from "app/financeKnowledge/hooks";

export const FinanceKnowledgeContainer = ({ knowledgeKey }: { knowledgeKey: string }) => {
    const [title, text] = useFinanceKnowledge(knowledgeKey);

    if (!title || !text) {
        return null;
    }

    return <FinanceKnowledge title={title} text={text} />;
};
